// extracted by mini-css-extract-plugin
export default {"tableu":"pendingPharmacistList_tableu__Ex45H","isloading":"pendingPharmacistList_isloading__s7ygK"};